import React from 'react';
import { IView } from 'interfaces/common';
import { IRoles } from 'interfaces/roles.interface';

const KnowledgeViewBase: IView = {
  key: 'viewKnowledgeBase',
  title: 'knowledgePages.basicView.knowledgePages',
  roles: [IRoles.ADMINISTRATOR, IRoles.EMPLOYEE, IRoles.NEWEMPLOYEE, IRoles.SUPERIOR, IRoles.HR, IRoles.BUDDY],
  view: React.lazy(() => import('./knowledge-base-page')),
  navigation: true,
  path: '/knowledge-base',
};

export default KnowledgeViewBase;
